import { render, staticRenderFns } from "./Haxan.vue?vue&type=template&id=ef564330&scoped=true"
import script from "./Haxan.vue?vue&type=script&lang=js"
export * from "./Haxan.vue?vue&type=script&lang=js"
import style0 from "./Haxan.vue?vue&type=style&index=0&id=ef564330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef564330",
  null
  
)

export default component.exports